import { render, staticRenderFns } from "./SummaryForLog.vue?vue&type=template&id=1954bbe4"
import script from "./SummaryForLog.vue?vue&type=script&lang=js"
export * from "./SummaryForLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports